import React from "react";
import clsx from "clsx";
export default function ErrorText({ children, className, ...props }) {
    return (
        <p className={clsx("tw-text-red-600 tw-font-sans tw-text-sm tw-mt-1 tw-mb-0", className)}      {...props}>
            {children}
        </p>
    );}